import cx from "classnames"
import * as React from "react"
import * as styles from "./styles.module.scss"

const MissionQuote: React.FC = () => {
  return (
    <section className={styles.quote}>
      <div className={styles.pagePadding}>
        <blockquote className={styles.blockquote}>
          <div className={styles.quoteWrap}>
            <i
              className={cx({
                [styles.quotationMark]: true,
                ["bsk-icon-quote"]: true,
              })}
            />
            <q className={styles.quote}>
              We’re just getting started. We won’t rest until you can get a
              mortgage in one day at no cost.
            </q>
          </div>
          <cite className={styles.author}>
            Vishal Garg, <span className={styles.title}>CEO</span>
          </cite>
        </blockquote>
      </div>
    </section>
  )
}

export default MissionQuote
